import axios from "@/plugins/axios";
import utils from "@/stores/utils";
import establishments from "./module-establishments";

const state = {
    product: null,
    selected_establishments: [],
    saving: false,
};

const mutations = {
    updateProduct(state, product) {
        state.product = product;
    },
    selectEstablishment(state, establishmentId) {
        if (!state.selected_establishments.includes(establishmentId)) {
            state.selected_establishments.push(establishmentId);
        }
    },
    deselectEstablishment(state, establishmentId) {
        state.selected_establishments = state.selected_establishments.filter(id => id !== establishmentId);
    },
    toggleEstablishment(state, establishmentId) {
        if (!state.selected_establishments.includes(establishmentId)) {
            state.selected_establishments.push(establishmentId);
        } else {
            state.selected_establishments = state.selected_establishments.filter(id => id !== establishmentId);
        }
        console.log(establishmentId, state.selected_establishments);
    },
    updateSelectedEstablishments(state, establishmentIds) {
        state.selected_establishments = establishmentIds;
    },
    updateSaving(state, saving) {
        state.saving = saving;
    },
};

const actions = {
    async bulkSetEstablishments({ commit, state }) {
        if (!state.product) {
            throw new Error('Product not loaded');
        }
        
        // Handle product being either an ID or an object with an id property
        const productId = state.product.id || state.product;
        
        commit('updateSaving', true);
        try {
            const response = await axios.post(
                `/api/products/${productId}/bulk-set-establishments/`,
                { establishment_ids: state.selected_establishments }
            );
            return response.data;
        } catch (error) {
            throw utils.handleError(error);
        } finally {
            commit('updateSaving', false);
        }
    },

    async init({ commit, dispatch }, params) {
        commit('updateProduct', params.product);
        commit('updateSelectedEstablishments', params.selectedEstablishments || []);
    },
};

const getters = {
    product: state => state.product,
    selected_establishments: state => state.selected_establishments,
    saving: state => state.saving,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
    modules: {
        establishments,
    },
};

